import React from 'react';

import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import { CLASSIC_TYPO } from 'theme/typography';
import globalMessages from 'translations/messages/global-messages';

const styles = () => ({
  srOnly: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: '0',
  },
  errorWrapper: {
    margin: 'auto',
    width: 'fit-content',
  },
});

const Error = ({ title = '', description = '', intl, classes, customStyle, ...otherProps }) => {
  return (
    <div className={classes.errorWrapper}>
      <svg
        aria-hidden="true"
        focusable="false"
        width="401"
        height="344"
        viewBox="0 0 401 344"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={customStyle}
        {...otherProps}
      >
        <title>
          <Typography component="h1" variant="header">
            {title || intl.formatMessage(globalMessages.error)}
          </Typography>
        </title>
        <path
          d="M323.663 96.5835H363.338L391.417 124.663V164.338L363.338 192.417H323.663L295.583 164.338V124.663L323.663 96.5835Z"
          stroke="#F4F6F8"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
        />

        <path
          d="M357.875 130.125L329.125 158.875"
          stroke="#F4F6F8"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M329.125 130.125L357.875 158.875"
          stroke="#F4F6F8"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M214.27 5.6665H237.73L254.333 22.2698V45.7298L237.73 62.3332H214.27L197.667 45.7298V22.2698L214.27 5.6665Z"
          stroke="#F4F6F8"
          strokeWidth="2.95652"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
        />

        <path
          d="M234.5 25.5L217.5 42.5"
          stroke="#F4F6F8"
          strokeWidth="2.95652"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M217.5 25.5L234.5 42.5"
          stroke="#F4F6F8"
          strokeWidth="2.95652"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M84.9667 286.5C84.5895 287.355 84.477 288.303 84.6437 289.222C84.8103 290.141 85.2485 290.989 85.9017 291.657L86.0717 291.827C86.5986 292.353 87.0165 292.978 87.3017 293.666C87.5869 294.354 87.7337 295.091 87.7337 295.836C87.7337 296.581 87.5869 297.318 87.3017 298.006C87.0165 298.694 86.5986 299.319 86.0717 299.845C85.5454 300.372 84.9205 300.79 84.2325 301.075C83.5446 301.36 82.8072 301.507 82.0625 301.507C81.3179 301.507 80.5805 301.36 79.8925 301.075C79.2046 300.79 78.5797 300.372 78.0534 299.845L77.8834 299.675C77.2156 299.022 76.3675 298.584 75.4484 298.417C74.5293 298.25 73.5813 298.363 72.7267 298.74C71.8887 299.099 71.174 299.696 70.6706 300.456C70.1672 301.216 69.897 302.107 69.8934 303.018V303.5C69.8934 305.003 69.2963 306.444 68.2336 307.507C67.1709 308.57 65.7296 309.167 64.2267 309.167C62.7238 309.167 61.2825 308.57 60.2198 307.507C59.1571 306.444 58.56 305.003 58.56 303.5V303.245C58.5381 302.307 58.2345 301.398 57.6888 300.635C57.1431 299.872 56.3805 299.291 55.5 298.967C54.6455 298.59 53.6975 298.477 52.7784 298.644C51.8593 298.81 51.0111 299.249 50.3434 299.902L50.1734 300.072C49.6471 300.599 49.0221 301.017 48.3342 301.302C47.6463 301.587 46.9089 301.734 46.1642 301.734C45.4195 301.734 44.6821 301.587 43.9942 301.302C43.3063 301.017 42.6813 300.599 42.155 300.072C41.6282 299.546 41.2102 298.921 40.925 298.233C40.6399 297.545 40.4931 296.807 40.4931 296.063C40.4931 295.318 40.6399 294.581 40.925 293.893C41.2102 293.205 41.6282 292.58 42.155 292.053L42.325 291.883C42.9782 291.216 43.4164 290.368 43.5831 289.448C43.7497 288.529 43.6372 287.581 43.26 286.727C42.9009 285.889 42.3045 285.174 41.5444 284.671C40.7842 284.167 39.8934 283.897 38.9817 283.893H38.5C36.9971 283.893 35.5558 283.296 34.4931 282.234C33.4304 281.171 32.8334 279.73 32.8334 278.227C32.8334 276.724 33.4304 275.283 34.4931 274.22C35.5558 273.157 36.9971 272.56 38.5 272.56H38.755C39.6929 272.538 40.6024 272.235 41.3654 271.689C42.1284 271.143 42.7096 270.381 43.0334 269.5C43.4105 268.646 43.523 267.698 43.3564 266.778C43.1897 265.859 42.7516 265.011 42.0984 264.343L41.9284 264.173C41.4015 263.647 40.9835 263.022 40.6984 262.334C40.4132 261.646 40.2664 260.909 40.2664 260.164C40.2664 259.42 40.4132 258.682 40.6984 257.994C40.9835 257.306 41.4015 256.681 41.9284 256.155C42.4547 255.628 43.0796 255.21 43.7675 254.925C44.4555 254.64 45.1929 254.493 45.9375 254.493C46.6822 254.493 47.4196 254.64 48.1075 254.925C48.7955 255.21 49.4204 255.628 49.9467 256.155L50.1167 256.325C50.7845 256.978 51.6326 257.417 52.5517 257.583C53.4708 257.75 54.4188 257.637 55.2734 257.26H55.5C56.3381 256.901 57.0528 256.305 57.5562 255.544C58.0596 254.784 58.3297 253.894 58.3334 252.982V252.5C58.3334 250.997 58.9304 249.556 59.9931 248.493C61.0558 247.431 62.4971 246.833 64 246.833C65.5029 246.833 66.9443 247.431 68.007 248.493C69.0697 249.556 69.6667 250.997 69.6667 252.5V252.755C69.6703 253.667 69.9405 254.558 70.4439 255.318C70.9473 256.078 71.662 256.674 72.5 257.033C73.3546 257.411 74.3026 257.523 75.2217 257.357C76.1408 257.19 76.9889 256.752 77.6567 256.098L77.8267 255.928C78.353 255.402 78.978 254.984 79.6659 254.698C80.3538 254.413 81.0912 254.267 81.8359 254.267C82.5806 254.267 83.3179 254.413 84.0059 254.698C84.6938 254.984 85.3188 255.402 85.845 255.928C86.3719 256.455 86.7899 257.08 87.075 257.768C87.3602 258.456 87.507 259.193 87.507 259.938C87.507 260.682 87.3602 261.42 87.075 262.108C86.7899 262.796 86.3719 263.421 85.845 263.947L85.675 264.117C85.0219 264.785 84.5837 265.633 84.417 266.552C84.2504 267.471 84.3629 268.419 84.74 269.273V269.5C85.0992 270.338 85.6956 271.053 86.4557 271.556C87.2159 272.06 88.1066 272.33 89.0184 272.333H89.5C91.0029 272.333 92.4443 272.931 93.507 273.993C94.5697 275.056 95.1667 276.497 95.1667 278C95.1667 279.503 94.5697 280.944 93.507 282.007C92.4443 283.07 91.0029 283.667 89.5 283.667H89.245C88.3333 283.67 87.4425 283.941 86.6824 284.444C85.9222 284.947 85.3259 285.662 84.9667 286.5Z"
          stroke="#F4F6F8"
          strokeWidth="2.95652"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
        />

        <path
          d="M64 286.5C68.6945 286.5 72.5 282.695 72.5 278C72.5 273.306 68.6945 269.5 64 269.5C59.3056 269.5 55.5 273.306 55.5 278C55.5 282.695 59.3056 286.5 64 286.5Z"
          stroke="#F4F6F8"
          strokeWidth="2.95652"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
        />

        <path
          d="M357 31.1668C364.824 31.1668 371.167 24.8242 371.167 17.0002C371.167 9.17613 364.824 2.8335 357 2.8335C349.176 2.8335 342.833 9.17613 342.833 17.0002C342.833 24.8242 349.176 31.1668 357 31.1668Z"
          stroke="#CED2D8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
        />

        <path
          d="M351.333 22.6668L353.87 21.3987C355.84 20.4134 358.16 20.4134 360.131 21.3987L362.667 22.6668"
          stroke="#CED2D8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
        />

        <path
          d="M352.042 13.4585V13.3168"
          stroke="#CED2D8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M361.958 13.4585V13.3168"
          stroke="#CED2D8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g filter="url(#filter0_d)">
          <rect x="137.56" y="144.799" width="202.28" height="140.231" rx="14.6848" fill="white" />
          <text
            x="158"
            y="261"
            fontFamily={CLASSIC_TYPO}
            fontWeight="400"
            fontSize="11"
            fill="#848F9D"
          >
            {description || intl.formatMessage(globalMessages.ooops)}
          </text>
          <path
            d="M158.444 227.463H164.773V229.093H160.294V231.634H163.643V233.278H160.294V237.258H158.444V227.463ZM164.914 233.807C164.914 233.308 165.003 232.838 165.179 232.397C165.365 231.947 165.619 231.555 165.942 231.222C166.265 230.89 166.652 230.625 167.102 230.429C167.563 230.234 168.067 230.136 168.615 230.136C169.163 230.136 169.663 230.234 170.113 230.429C170.573 230.625 170.965 230.89 171.288 231.222C171.611 231.555 171.86 231.947 172.037 232.397C172.223 232.838 172.316 233.308 172.316 233.807C172.316 234.306 172.223 234.781 172.037 235.231C171.86 235.672 171.611 236.063 171.288 236.406C170.965 236.739 170.573 237.003 170.113 237.199C169.663 237.395 169.163 237.493 168.615 237.493C168.067 237.493 167.563 237.395 167.102 237.199C166.652 237.003 166.265 236.739 165.942 236.406C165.619 236.063 165.365 235.672 165.179 235.231C165.003 234.781 164.914 234.306 164.914 233.807ZM168.615 235.995C168.948 235.995 169.237 235.931 169.481 235.804C169.726 235.667 169.927 235.491 170.083 235.275C170.25 235.06 170.372 234.825 170.451 234.57C170.529 234.316 170.568 234.061 170.568 233.807C170.568 233.562 170.529 233.312 170.451 233.058C170.372 232.794 170.25 232.559 170.083 232.353C169.927 232.138 169.726 231.966 169.481 231.839C169.237 231.702 168.948 231.634 168.615 231.634C168.282 231.634 167.993 231.702 167.749 231.839C167.504 231.966 167.298 232.138 167.132 232.353C166.975 232.559 166.858 232.794 166.779 233.058C166.701 233.312 166.662 233.562 166.662 233.807C166.662 234.061 166.701 234.316 166.779 234.57C166.858 234.825 166.975 235.06 167.132 235.275C167.298 235.491 167.504 235.667 167.749 235.804C167.993 235.931 168.282 235.995 168.615 235.995ZM173.698 230.371H175.358L175.402 231.237C175.48 231.139 175.578 231.031 175.696 230.914C175.823 230.797 175.97 230.689 176.136 230.591C176.303 230.493 176.493 230.41 176.709 230.341C176.934 230.273 177.189 230.238 177.472 230.238C177.639 230.238 177.786 230.248 177.913 230.268C178.05 230.287 178.187 230.322 178.324 230.371L177.972 232.001C177.854 231.952 177.732 231.917 177.605 231.898C177.487 231.878 177.345 231.868 177.179 231.868C176.944 231.868 176.719 231.908 176.503 231.986C176.288 232.064 176.102 232.177 175.945 232.324C175.789 232.471 175.661 232.647 175.563 232.852C175.475 233.058 175.431 233.288 175.431 233.543V237.258H173.698V230.371ZM179.306 230.371H180.965L181.009 231.149C181.097 231.051 181.195 230.948 181.303 230.841C181.42 230.723 181.557 230.62 181.714 230.532C181.88 230.444 182.066 230.371 182.272 230.312C182.487 230.253 182.732 230.224 183.006 230.224C183.917 230.224 184.607 230.557 185.077 231.222C185.429 230.86 185.787 230.606 186.149 230.459C186.521 230.302 186.952 230.224 187.441 230.224C188.312 230.224 188.978 230.483 189.438 231.002C189.908 231.511 190.143 232.201 190.143 233.073V237.258H188.41V233.087C188.41 232.647 188.298 232.309 188.072 232.074C187.857 231.829 187.559 231.707 187.177 231.707C186.942 231.707 186.726 231.756 186.531 231.854C186.335 231.942 186.163 232.069 186.017 232.236C185.88 232.402 185.772 232.598 185.694 232.823C185.625 233.038 185.591 233.273 185.591 233.528V237.258H183.858V233.087C183.858 232.647 183.745 232.309 183.52 232.074C183.305 231.829 183.006 231.707 182.624 231.707C182.389 231.707 182.174 231.756 181.978 231.854C181.782 231.942 181.611 232.069 181.464 232.236C181.327 232.402 181.22 232.598 181.141 232.823C181.073 233.038 181.038 233.273 181.038 233.528V237.258H179.306V230.371Z"
            fill="#172134"
          />
        </g>
        <circle opacity="0.1" cx="146.033" cy="154.874" r="145.874" fill="#848F9D" />
        <g filter="url(#filter1_d)">
          <rect x="107.56" y="114.799" width="202.28" height="140.231" rx="14.6848" fill="white" />
          <text
            x="128"
            y="206"
            fontFamily={CLASSIC_TYPO}
            fontWeight="500"
            fontSize="15"
            fill="#172134"
          >
            {title || intl.formatMessage(globalMessages.error)}
          </text>
          <text
            x="128"
            y="229"
            fontFamily={CLASSIC_TYPO}
            fontWeight="400"
            fontSize="11"
            fill="#848F9D"
          >
            {description || intl.formatMessage(globalMessages.ooops)}
          </text>
        </g>
        <circle opacity="0.2" cx="146.033" cy="154.875" r="68.9297" fill="#848F9D" />
        <circle cx="145.339" cy="154.18" r="21.7481" fill="#FF8029" />
        <path
          d="M145.339 163.242C150.343 163.242 154.4 159.184 154.4 154.18C154.4 149.175 150.343 145.118 145.339 145.118C140.334 145.118 136.277 149.175 136.277 154.18C136.277 159.184 140.334 163.242 145.339 163.242Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="#FF8029"
        />

        <path
          d="M141.714 157.805L142.208 157.557C144.179 156.572 146.498 156.572 148.469 157.557L148.963 157.805"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M142.167 151.915V151.823"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M148.51 151.915V151.823"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <defs>
          <filter
            id="filter0_d"
            x="87.4303"
            y="102.721"
            width="302.54"
            height="240.491"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />

            <feOffset dy="8.05257" />
            <feGaussianBlur stdDeviation="25.065" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0901961 0 0 0 0 0.129412 0 0 0 0 0.203922 0 0 0 0.1 0"
            />

            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter1_d"
            x="57.4303"
            y="72.7219"
            width="302.54"
            height="240.491"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />

            <feOffset dy="8.05257" />
            <feGaussianBlur stdDeviation="25.065" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0901961 0 0 0 0 0.129412 0 0 0 0 0.203922 0 0 0 0.1 0"
            />

            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
        </defs>
      </svg>
      <span className={classes.srOnly}>{title || intl.formatMessage(globalMessages.error)}</span>
    </div>
  );
};

Error.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  intl: PropTypes.object.isRequired,
  customStyle: PropTypes.object,
};

export default compose(injectIntl, withStyles(styles))(Error);
